/* src/app/pages/ui-kit/components/counter-view/counter-view.component.scss */
.box {
  display: flex;
  gap: 14px;
  align-items: center;
  margin-bottom: 30px;
}
/*# sourceMappingURL=counter-view.component.css.map */
